<script>
  import ServiceProviderCreate from '@/ServiceProviderCreate';
  
  export default {
    name: 'ServiceProviderEdit',
    mixins: [
      ServiceProviderCreate
    ],
    methods: {
      saveProvider () {
        this.$v.provider.$touch();
        if (this.$v.provider.$error) {
          this.$q.notify('Please review fields again.');
          return;
        }
        this.visible = false;
        this.$http.put(`/api/v1.0/service-providers/${this.provider.id}`, this.provider).then(response => {
          this.$q.notify({
            message: 'Сохранено',
            type: 'positive'
          });
          this.$emit('save');
        }).catch(error => {
          _.forIn(error.response.data.errors, (value, key) => {
            this.$q.notify({message: value[0], type: 'negative'});
          });
        });
      },
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServiceProviderEdit/ServiceProviderEdit.vue